import { takeLatest, put, call } from 'redux-saga/effects';
import * as BulkCaseActions from '../action'
import { FETCH_QUICK_REPORT_CASES , FETCH_PRODUCT_DETAIL_BY_PRODUCT_ID, fetchProductDetailFailureResponse, fetchProductDetailSuccessResponse , UPLOAD_MANUL_SECTION_DATA, uploadManualSectionDataResponse,
    downloadManualSectiontemplateResponse, DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_REQUEST, DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_REQUEST, downloadQuickReportSummaryResponse, downloadQuickReportCaseCreationTemplateResponse, 
    DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_REQUEST,DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_REQUEST,downloadQuickReportStatusFileResponse, DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_REQUEST, downloadQuickReportCrawlerStatusFileResponse,
    INITIATE_OR_STOP_QUICK_CRAWLERS_REQUEST, initiateOrStopQuickCrawlersResponse } from './action'
import { HTTP_HEADERS, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../../constants';
import request from '../../../../components/Utils/httpHelper';
import { CRAWLER_TEMPLATE } from "./constant"
import { CORE_API, REPORT } from '../../../../config'


export function* fetchUploadList(action) {
    let requestUrl = `${CORE_API}/bulkcase/quick-record/${action.data.pageNumber}/${action.data.pageSize}/sort/${action.data.sortField}/${action.data.sortDirection}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(BulkCaseActions.fetchUploadListSuccess(searchResult.data));
    } catch (err) {
        yield put(BulkCaseActions.fetchUploadListFailure(err.response))
    }
}

export function* fetchQuickReportCases() {
    
    yield takeLatest(FETCH_QUICK_REPORT_CASES, fetchUploadList);
}


export function* fetchProductDetailByProductId(){
    yield takeLatest(FETCH_PRODUCT_DETAIL_BY_PRODUCT_ID, fetchProductDetail);
}



export function* fetchProductDetail(action) {
    let requestUrl = action.data.type === CRAWLER_TEMPLATE ? `${REPORT}/quickreport/crawler/section/${action.data.productId}` : `${REPORT}/product/${action.data.productId}`;

    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchProductDetailSuccessResponse(searchResult.data));
    } catch (err) {
        yield put(fetchProductDetailFailureResponse(err.response))
    }
}


export function* uploadManualSectionData(action) {
    const formData = new FormData();
    formData.append('sectionTemplateId', action.data.sectionTemplateId)
    formData.append('file', action.data.file);
    formData.append('corporateId', action.data.corporateId);
    let requestUrl = action.data.type === CRAWLER_TEMPLATE ? `${REPORT}/quickreport/crawler/initiate`:`${REPORT}/survey/upload-manual-data`;
    try {
        const listResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS });
        yield put(uploadManualSectionDataResponse({message : listResult.data, status : "SUCCESS"}));
    } catch (err) {
        yield put(uploadManualSectionDataResponse({...err.response, status : "FAILURE"}));
    }
}

export function* uploadSectionData(){
    yield takeLatest(UPLOAD_MANUL_SECTION_DATA, uploadManualSectionData);

}

export function* downloadManualSectiontemplate(action) {
    let requestUrl = action.data.type === CRAWLER_TEMPLATE ? `${REPORT}/quickreport/crawler/template/${action.data.quickCaseCreationRecordId}/${action.data.sectionTemplateId}` : `${REPORT}/quickreport/section/template/${action.data.quickCaseCreationRecordId}/${action.data.sectionTemplateId}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadManualSectiontemplateResponse({data : result.data, status :"SUCCESS"}));
    } catch (err) {
       yield put(downloadManualSectiontemplateResponse({result :err, status : "FAILURE"}))
    }
}

export function* downloadManualSectionTemplateForQuickReport() {
    yield takeLatest(DOWNLOAD_MANUL_SECTION_DATA_TEMPLATE_REQUEST, downloadManualSectiontemplate);
}


export function* downloadQuickReportSummary(action) {
    let requestUrl = `${REPORT}/quickreport/summary/${action.data.quickCaseCreationRecordId}`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadQuickReportSummaryResponse({ data :result.data, status :"SUCCESS"}));
    } catch (err) {
       yield put(downloadQuickReportSummaryResponse({result :err, status : "FAILURE"}))
    }
}

export function* downloadQuickReportCaseSummary() {
    yield takeLatest(DOWNLOAD_QUICK_REPORT_CASE_SUMMARY_REQUEST, downloadQuickReportSummary);
}


export function* downloadQuickReportCreationTemplate(action) {
    let requestUrl = `${CORE_API}/quickreport/template`;
    try {
        const result = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadQuickReportCaseCreationTemplateResponse({ data :result.data, status :"SUCCESS"}));
    } catch (err) {
       yield put(downloadQuickReportCaseCreationTemplateResponse({result :err, status : "FAILURE"}))
    }
}

export function* downloadQuickReportCaseCreationTemplate() {
    yield takeLatest(DOWNLOAD_QUICK_REPORT_CASE_CREATION_TEMPLATE_REQUEST, downloadQuickReportCreationTemplate);
}


export function* downloadQuickReportStatusFileRequest (action){
    console.log(action)
    let requestUrl = `${CORE_API}/quickreport/s3/${action.data}`;
    console.log(requestUrl)
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(downloadQuickReportStatusFileResponse({data : searchResult.data , status :"SUCCESS" }));
    } catch (err) {
        yield put(downloadQuickReportStatusFileResponse({result :err, status : "FAILURE"}));
    }
}

export function* downloadQuickReportStatusFile(){
    yield takeLatest(DOWNLOAD_QUICK_REPORT_CASE_STATUS_FILE_REQUEST, downloadQuickReportStatusFileRequest)
}



export function* downloadQuickReportCrawlerStatusFileRequest (action){
    console.log(action)
    let requestUrl = `${REPORT}/quickreport/crawler-status/${action.data.quickCaseCreationRecordId}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadQuickReportCrawlerStatusFileResponse({data : searchResult.data , status :"SUCCESS" }));
    } catch (err) {
        yield put(downloadQuickReportCrawlerStatusFileResponse({result :err, status : "FAILURE"}));
    }
}

export function* downloadQuickReportCrawlerStatusFile(){
    yield takeLatest(DOWNLOAD_QUICK_REPORT_CASE_CRAWLER_STATUS_FILE_REQUEST, downloadQuickReportCrawlerStatusFileRequest)
}

//initiateOrStopQuickCrawlersResponse

export function* initiateOrStopQuickCrawlersRequest(action){
    let requestURL = `${REPORT}/crawler/initiate-stop-quick`
    try {
        const data = yield call(request, requestURL, { method: 'post', headers: HTTP_HEADERS});
        yield put(initiateOrStopQuickCrawlersResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(initiateOrStopQuickCrawlersResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* initiateOrStopQuickCrawlers(){
    yield takeLatest(INITIATE_OR_STOP_QUICK_CRAWLERS_REQUEST, initiateOrStopQuickCrawlersRequest)
}